var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScenario4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "business_center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5 7.79803H16.5V5.79803L14.5 3.79803H10.5L8.5 5.79803V7.79803H4.5C3.4 7.79803 2.5 8.69803 2.5 9.79803V14.798C2.5 15.548 2.9 16.178 3.5 16.528V19.798C3.5 20.908 4.39 21.798 5.5 21.798H19.5C20.61 21.798 21.5 20.908 21.5 19.798V16.518C22.09 16.168 22.5 15.528 22.5 14.798V9.79803C22.5 8.69803 21.6 7.79803 20.5 7.79803ZM10.5 5.79803H14.5V7.79803H10.5V5.79803ZM4.5 9.79803H20.5V14.798H15.5V11.798H9.5V14.798H4.5V9.79803ZM13.5 15.798H11.5V13.798H13.5V15.798ZM19.5 19.798H5.5V16.798H9.5V17.798H15.5V16.798H19.5V19.798Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 9",
    x: 10.5,
    y: 12.798,
    width: 4,
    height: 4,
    stroke: "#14AA40",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenario4);
export default __webpack_public_path__ + "static/media/Scenario4.8c1c0f2e9b97b2c4b1d05556d86803e3.svg";
export { ForwardRef as ReactComponent };